"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CannotCloseGridError = exports.CannotCloseGridTemplateError = exports.CannotCloseBorderError = exports.InvalidEdgesInputLengthError = exports.InvalidIntersectionValueError = exports.NoMandatoryPartMatchError = exports.NoDataTypeMatchError = exports.ShorthandParserError = void 0;
var tslib_1 = require("tslib");
var ShorthandParserError = /** @class */ (function (_super) {
    tslib_1.__extends(ShorthandParserError, _super);
    function ShorthandParserError(message, prop) {
        return _super.call(this, "Shorthand Parser Error! ".concat(prop ? '[' + prop + '] ' : '').concat(message)) || this;
    }
    return ShorthandParserError;
}(Error));
exports.ShorthandParserError = ShorthandParserError;
var NoDataTypeMatchError = /** @class */ (function (_super) {
    tslib_1.__extends(NoDataTypeMatchError, _super);
    function NoDataTypeMatchError(value) {
        return _super.call(this, "No data-type match: \"".concat(value, "\".")) || this;
    }
    return NoDataTypeMatchError;
}(ShorthandParserError));
exports.NoDataTypeMatchError = NoDataTypeMatchError;
var NoMandatoryPartMatchError = /** @class */ (function (_super) {
    tslib_1.__extends(NoMandatoryPartMatchError, _super);
    function NoMandatoryPartMatchError(prop, partProp) {
        return _super.call(this, "No mandatory match on shorthand part: \"".concat(partProp, "\"."), prop) || this;
    }
    return NoMandatoryPartMatchError;
}(ShorthandParserError));
exports.NoMandatoryPartMatchError = NoMandatoryPartMatchError;
var InvalidIntersectionValueError = /** @class */ (function (_super) {
    tslib_1.__extends(InvalidIntersectionValueError, _super);
    function InvalidIntersectionValueError(prop, value) {
        return _super.call(this, "Invalid value for intersection: \"".concat(value, "\""), prop) || this;
    }
    return InvalidIntersectionValueError;
}(ShorthandParserError));
exports.InvalidIntersectionValueError = InvalidIntersectionValueError;
var InvalidEdgesInputLengthError = /** @class */ (function (_super) {
    tslib_1.__extends(InvalidEdgesInputLengthError, _super);
    function InvalidEdgesInputLengthError(prop, length) {
        return _super.call(this, "Invalid edges input length: \"".concat(length, "\"."), prop) || this;
    }
    return InvalidEdgesInputLengthError;
}(ShorthandParserError));
exports.InvalidEdgesInputLengthError = InvalidEdgesInputLengthError;
var CannotCloseBorderError = /** @class */ (function (_super) {
    tslib_1.__extends(CannotCloseBorderError, _super);
    function CannotCloseBorderError() {
        return _super.call(this, "Cannot close border object.", 'border') || this;
    }
    return CannotCloseBorderError;
}(ShorthandParserError));
exports.CannotCloseBorderError = CannotCloseBorderError;
var CannotCloseGridTemplateError = /** @class */ (function (_super) {
    tslib_1.__extends(CannotCloseGridTemplateError, _super);
    function CannotCloseGridTemplateError() {
        return _super.call(this, "Cannot close grid-template object.", 'grid-template') || this;
    }
    return CannotCloseGridTemplateError;
}(ShorthandParserError));
exports.CannotCloseGridTemplateError = CannotCloseGridTemplateError;
var CannotCloseGridError = /** @class */ (function (_super) {
    tslib_1.__extends(CannotCloseGridError, _super);
    function CannotCloseGridError() {
        return _super.call(this, "Cannot close grid object.", 'grid') || this;
    }
    return CannotCloseGridError;
}(ShorthandParserError));
exports.CannotCloseGridError = CannotCloseGridError;
//# sourceMappingURL=shorthand-parser-errors.js.map